(() => {
  const prefix = '_olouioo_detail_';
  const operational = ['Setup date','Setup start','Finish time','Pack-down start','Pack-down complete','Event duration','Setup and pack-down allowance','Garnishes','Included drinks','Station','Refreshment setup','Station service','Drinkware','Linked experience','Water-service guests','Water style','Linked service'];
  const expand = properties => {
    const result = {...(properties || {})};
    for(const [name,value] of Object.entries(result))if(name.startsWith(prefix) && result[name.slice(prefix.length)] == null)result[name.slice(prefix.length)]=value;
    return result;
  };
  const compact = properties => {
    const result = {...(properties || {})};
    const component = result._olouioo_refreshment || result._olouioo_duration_component === 'true';
    const keys = component ? [...operational,'Event date','Start time','Hire duration'] : operational;
    if(component && (result['Linked experience'] || result[prefix+'Linked experience']))result.With=result['Linked experience'] || result[prefix+'Linked experience'];
    for(const name of keys)if(result[name] != null){result[prefix+name]=result[name];delete result[name];}
    return result;
  };
  const sourceFor = (item,cart) => {
    const p=item.properties || {};
    if(!p._olouioo_refreshment || !p._olouioo_source_product)return null;
    const sources=cart.items.filter(line=>String(line.product_id)===p._olouioo_source_product && line.properties?._olouioo_duration_component!=='true' && !line.properties?._olouioo_refreshment);
    return sources.find(line=>p._olouioo_source_hire_group && line.properties?._olouioo_hire_group===p._olouioo_source_hire_group) || sources.find(line=>String(line.variant_id)===p._olouioo_source_variant && String(line.quantity)===p._olouioo_source_quantity) || (sources.length===1?sources[0]:null);
  };
  window.OlouiooBookingProperties={expand,compact,sourceFor};
  const timingHandles=['la-table','la-table-signature-collection','l-or','la-coupe-welcome-toast-table','olouioo-signature-coupe-tower-setup-upgrade','le-chariot','reveil','noir','lumiere','le-chariot-signature-collection','le-jardin-garden-refreshment-table','le-botanique-interactive-botanical-bar'];
  const durationText=minutes=>[Math.floor(minutes/60)?Math.floor(minutes/60)+' h':'',minutes%60?minutes%60+' min':''].filter(Boolean).join(' ') || '0 min';
  const estimateTiming=items=>{
    const services=new Map(),stations=new Map();let hireHours=0;
    for(const item of items || []){
      const p=expand(item.properties),quantity=Math.max(0,Math.floor(Number(item.quantity)||0));
      if(!quantity || p._olouioo_duration_component==='true')continue;
      const handle=item.handle || p._olouioo_service_handle || '';
      if(!p._olouioo_refreshment && !timingHandles.includes(handle))continue;
      hireHours=Math.max(hireHours,Number(p._olouioo_duration_hours || item.hours) || (handle==='l-or'?3:6));
      if(p._olouioo_refreshment){
        const group=p._olouioo_refreshment_group || item.key || 'station';
        const bar=/bar/i.test(p['Refreshment setup'] || '') && /L[’']Or|l-or/i.test((p['Linked experience'] || '')+' '+(p['Refreshment setup'] || ''));
        stations.set(group,Math.max(stations.get(group)||0,bar?15:30));
      }else{
        const key=handle==='la-table-signature-collection'?'la-table':handle;
        services.set(key,(services.get(key)||0)+quantity);
      }
    }
    const setupMinutes=[...services].reduce((sum,[handle,count])=>sum+(handle==='la-table'?120+15*(count-1):120*count),0)+[...stations.values()].reduce((a,b)=>a+b,0);
    const packMinutes=setupMinutes?60:0;
    return {setupMinutes,packMinutes,hireHours,totalMinutes:setupMinutes+hireHours*60+packMinutes,tableCount:services.get('la-table')||0,stationCount:stations.size};
  };
  const buildSchedule=(event,nextDay='Next day',hours=3,allowance={setupMinutes:120,packMinutes:60})=>{
    const [h,m]=event.time.split(':').map(Number),start=h*60+m;
    const dateAt=offset=>{const d=new Date(event.date+'T00:00:00Z');d.setUTCDate(d.getUTCDate()+offset);return d.toISOString().slice(0,10);};
    const clock=n=>{const value=((n%1440)+1440)%1440,days=Math.floor(n/1440);return String(Math.floor(value/60)).padStart(2,'0')+':'+String(value%60).padStart(2,'0')+(days===1?' '+nextDay:days?' '+dateAt(days).split('-').reverse().join('/'):'');};
    const setup=Math.max(0,Number(allowance.setupMinutes)||0),pack=Math.max(0,Number(allowance.packMinutes)||0);
    return {'Event date':event.date,'Setup date':dateAt(Math.floor((start-setup)/1440)),'Start time':event.time,'Setup start':clock(start-setup),'Finish time':clock(start+hours*60),'Pack-down start':clock(start+hours*60),'Pack-down complete':clock(start+hours*60+pack),'Event duration':hours+' hours active hire','Setup and pack-down allowance':'Estimated setup: '+durationText(setup)+' before hire; pack-down: '+durationText(pack)+' after hire','_olouioo_setup_minutes':String(setup),'_olouioo_pack_minutes':String(pack),'_olouioo_event':'shared'};
  };
  let timingCart={items:[]};
  const selectionTiming=booking=>{
    const station=booking.closest('[data-rfs-root]');
    if(station?.olouiooTimingItems)return estimateTiming(station.olouiooTimingItems());
    const owner=booking.closest('product-form-component'),selected=window.OlouiooService?.read(owner);
    const handle=selected?.handle || booking.dataset.serviceHandle;
    const quantity=selected?.quantity || Number(owner?.querySelector('[name=quantity]')?.value)||1;
    const hours=Number(booking.querySelector('[data-hire-duration]')?.value)||selected?.hours||6;
    const items=[{handle,quantity,hours}];
    const productId=String(selected?.productId || booking.dataset.serviceId || '');
    document.querySelectorAll('[data-rfs-root]').forEach(root=>{if(root.dataset.timingSource===productId)items.push(...(root.olouiooReview?.timingItems?.() || []));});
    return estimateTiming(items);
  };
  window.OlouiooTiming={estimate:estimateTiming,forBooking:selectionTiming,duration:durationText,cart:()=>estimateTiming(timingCart.items),setCart:cart=>{if(Array.isArray(cart?.items))timingCart=cart;},apply:items=>{
    const allowance=estimateTiming(items);if(!allowance.setupMinutes)return items;
    items.forEach(item=>{const p=expand(item.properties);if(p['Event date'] && p['Start time'])item.properties=compact({...p,...buildSchedule({date:p['Event date'],time:p['Start time']},'Next day',Number(p._olouioo_duration_hours)||3,allowance)});});return items;
  }};
  const root = () => window.Shopify?.routes?.root || '/';
  const key = 'olouioo:event:v2';
  const types = ['Self-Serve Experience', 'Hosted Experience', 'Complete Your Event', 'Event Hire'];
  const handles = ['olouioo-signature-drinks', 'olouioo-signature-coupe-tower-setup-upgrade', 'la-table', 'le-chariot', 'l-or', 'reveil', 'noir', 'lumiere', 'la-table-signature-collection', 'le-chariot-signature-collection', 'le-jardin-garden-refreshment-table', 'la-coupe-welcome-toast-table', 'le-botanique-interactive-botanical-bar'];
  const eligible = item => types.includes(item.product_type) || handles.includes(item.handle) || Boolean(pair(item.properties).date);
  const pair = properties => ({ date: expand(properties)['Event date'] || '', time: expand(properties)['Start time'] || '' });
  const same = (a, b) => a.date === b.date && a.time === b.time;
  const today = () => { const d = new Date(); d.setMinutes(d.getMinutes() - d.getTimezoneOffset()); return d.toISOString().slice(0, 10); };
  const valid = event => /^\d{4}-\d{2}-\d{2}$/.test(event.date) && event.date >= today() && /^(09|1\d|20):(00|15|30|45)$|^21:00$/.test(event.time);
  const schedule = buildSchedule;
  const itemHours = item => {
    const hours = Number(item.properties?._olouioo_duration_hours) || Number(item.properties?.['Event duration']?.match(/\d+/)?.[0]) || 3;
    return Number.isInteger(hours) && ((hours >= 3 && hours <= 13) || hours === 24 || hours === 48 || hours === 72) ? hours : 3;
  };
  const expected = (item,cart,event) => {
    const source=sourceFor(item,cart),hours=itemHours(source || item);
    const properties={...expand(item.properties),...schedule(event,nextDay,hours,estimateTiming(cart.items))};
    if(source)Object.assign(properties,{_olouioo_duration_hours:String(hours),'Hire duration':expand(source.properties)['Hire duration'] || hours+' hours',_olouioo_source_hire_group:source.properties?._olouioo_hire_group || '',_olouioo_source_variant:String(source.variant_id),_olouioo_source_quantity:String(source.quantity)});
    return compact(properties);
  };
  const equalProperties = (a,b) => Object.keys(a || {}).length===Object.keys(b).length && Object.entries(b).every(([name,value])=>a?.[name]===value);
  let state = { date: '', time: '' };
  try { const saved = JSON.parse(sessionStorage.getItem(key)); if (saved && typeof saved.date === 'string' && typeof saved.time === 'string') state = saved; } catch {}
  let eventExpanded = false;
  let revision = 0;
  let syncing = false;
  let timer;
  let tail = Promise.resolve();
  let lastPersisted = null;
  let cartRevision = 0;
  const pendingSaves = new Map();
  let status = '';
  let nextDay = 'Next day';
  async function request(path, body) {
    const response = await fetch(root() + path, { cache: 'no-store', headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, ...(body ? { method: 'POST', body: JSON.stringify(body) } : {}) });
    const data = await response.json();
    if (!response.ok || data.status >= 400) throw new Error('Event details could not be saved.');
    window.OlouiooTiming.setCart(data);
    return data;
  }
  function showStatus(value) {
    status = value;
    document.querySelectorAll('[data-event-sync-status]').forEach(node => {
      node.textContent = node.dataset[value] || '';
      node.dataset.state = value;
    });
    document.querySelectorAll('[data-shared-save]').forEach(button => { button.hidden = value !== 'error'; });
  }
  function reflect() {
    syncing = true;
    document.querySelectorAll('event-booking-fields').forEach(booking => {
      const date = booking.querySelector('[data-event-date]');
      const time = booking.querySelector('[data-start-time]');
      if (!date || !time) return;
      date.readOnly = false;
      time.removeAttribute('aria-disabled');
      time.style.pointerEvents = '';
      time.removeAttribute('tabindex');
      date.value = state.date; time.value = state.time;
      date.dispatchEvent(new Event('change', { bubbles: true }));
      time.dispatchEvent(new Event('change', { bubbles: true }));
    });
    document.querySelectorAll('olouioo-event-cart').forEach(card => {
      card.querySelector('[data-shared-date]').value = state.date;
      card.querySelector('[data-shared-time]').value = state.time;
      const timing=window.OlouiooTiming.cart();
      card.querySelector('[data-shared-setup]').textContent = valid(state)?schedule(state,nextDay,timing.hireHours,timing)['Setup date']:state.date || '—';
      const values={'setup':durationText(timing.setupMinutes),'hire':durationText(timing.hireHours*60),'pack':durationText(timing.packMinutes),'total':durationText(timing.totalMinutes)};
      for(const [name,value]of Object.entries(values)){const output=card.querySelector('[data-shared-timing-'+name+']');if(output)output.textContent=value;}
      const timeline=card.querySelector('[data-shared-timing]');if(timeline)timeline.hidden=!timing.setupMinutes;
    });
    syncing = false;
    showStatus(status);
  }
  const ready = request('cart.js').then(cart => {
    if (!revision && !state.date && !state.time) {
      const saved = pair(cart.attributes);
      const first = cart.items.find(item => eligible(item) && pair(item.properties).date);
      state = saved.date && saved.time ? saved : first ? pair(first.properties) : state;
    }
    if (valid(state) && same(pair(cart.attributes), state) && cart.attributes?.['Setup date'] === state.date && (cart.items || []).filter(eligible).every(item => equalProperties(item.properties,expected(item,cart,state)))) lastPersisted = { ...state };
    reflect();
  }).catch(() => {});
  function setEvent(event) {
    const next = { date: event.date || '', time: event.time || '' };
    if (same(next, state)) return;
    state = next;
    lastPersisted = null;
    revision++;
    try { sessionStorage.setItem(key, JSON.stringify(state)); } catch {}
    reflect();
    clearTimeout(timer);
    if (!valid(state)) { showStatus(''); return; }
    showStatus('saving');
    timer = setTimeout(() => { flush().catch(() => {}); }, 250);
  }
  async function refresh(cart) {
    const { CartUpdateEvent } = await import('@theme/events');
    document.dispatchEvent(new CartUpdateEvent({}, 'olouioo-event', { itemCount: cart.item_count, sections: cart.sections, autoOpenDrawer: false }));
  }
  // quiet: skip the server-side cart re-render and UI refresh. Used right before an
  // add-to-cart (whose own response re-renders the cart) and right before checkout
  // (where the page is about to navigate away), so the shopper is not kept waiting
  // on a section render nobody will see.
  async function persist(event, quiet = false) {
    let cart = await request('cart.js');
    for (const item of cart.items) {
      if (!eligible(item)) continue;
      if ((item.properties?.['_olouioo_blocked_dates'] || '').split(/[\s,]+/).includes(event.date)) throw new Error('Unavailable event date.');
    }
    let changed = false;
    let remaining = cart.items.length * 2 + 5;
    while (remaining-- > 0) {
      const item = cart.items.find(item => eligible(item) && !equalProperties(item.properties,expected(item,cart,event)));
      if (!item) break;
      changed = true;
      cart = await request('cart/change.js', { id: item.key, quantity: item.quantity, properties: expected(item,cart,event) });
    }
    if (remaining < 0) throw new Error('Event details could not be saved.');
    const setupDate=schedule(event,nextDay,window.OlouiooTiming.cart().hireHours,window.OlouiooTiming.cart())['Setup date'];
    if (!changed && cart.attributes?.['Event date'] === event.date && cart.attributes?.['Setup date'] === setupDate && cart.attributes?.['Start time'] === event.time) {reflect();notifyTiming();return cart;}
    const sections = quiet ? [] : [...new Set([...document.querySelectorAll('cart-items-component')].map(node => node.sectionId || node.dataset.sectionId).filter(Boolean))].slice(0, 5);
    cart = await request('cart/update.js', { attributes: { 'Event date': event.date, 'Setup date': setupDate, 'Start time': event.time }, ...(sections.length ? { sections, sections_url: location.pathname } : {}) });
    if (!quiet) { try { await refresh(cart); } catch (error) { console.warn('Event details saved; cart display could not refresh.', error); } }
    reflect();notifyTiming();
    return cart;
  }
  async function flush(quiet = false) {
    clearTimeout(timer);
    await ready;
    const event = { ...state };
    if (!valid(event)) throw new Error('Choose a valid date and time.');
    if (lastPersisted && same(lastPersisted, event)) return;
    const saveKey = JSON.stringify(event);
    if (pendingSaves.has(saveKey)) return pendingSaves.get(saveKey);
    const task = tail.catch(() => {}).then(async () => {
      if (!same(event, state)) return;
      if (lastPersisted && same(lastPersisted, event)) return;
      showStatus('saving');
      const savedCartRevision = cartRevision;
      const panels = [...document.querySelectorAll('cart-items-component .cart-item__quantity, cart-items-component .cart-item__remove')];
      const inert = panels.map(node => node.inert);
      panels.forEach(node => { node.inert = true; });
      try {
        await persist(event, quiet);
        if (same(event, state)) { if (cartRevision === savedCartRevision) lastPersisted = { ...event }; showStatus('saved'); }
      } catch (error) {
        if (same(event, state)) showStatus('error');
        throw error;
      } finally {
        panels.forEach((node, i) => { node.inert = inert[i]; });
      }
    });
    tail = task;
    pendingSaves.set(saveKey, task);
    try { return await task; }
    finally { if (pendingSaves.get(saveKey) === task) pendingSaves.delete(saveKey); }
  }
  const hydrated = new WeakSet();
  async function hydrate(booking) {
    if (!hydrated.has(booking)) {
      hydrated.add(booking);
      const date = booking.querySelector('[data-event-date]');
      const time = booking.querySelector('[data-start-time]');
      nextDay = booking.dataset.nextDay || nextDay;
      const changed = () => {
        if (syncing) return;
        if (!date.checkValidity() || (time.value && !time.checkValidity())) return;
        setEvent({ date: date.value, time: time.value });
      };
      date.addEventListener('change', changed);
      time.addEventListener('change', changed);
    }
    await ready;
    reflect();
  }
  async function prepare(booking, data) {
    await ready;
    const event = { date: data.get('properties[Event date]'), time: data.get('properties[Start time]') };
    if (!valid(event)) throw new Error(booking.dataset.timeError);
    if ((booking.dataset.blockedDates || '').split(/[\s,]+/).includes(event.date)) throw new Error(booking.dataset.dateError);
    if (!same(event, state)) setEvent(event);
    // The add-to-cart request that follows re-renders the cart, so save quietly here.
    try { await flush(true); } catch { showStatus('error'); }
    if (!same(event, state)) throw new Error(booking.dataset.timeError);
    Object.entries(schedule(state, booking.dataset.nextDay, Number(booking.querySelector('[data-hire-duration]')?.value || data.get('properties[_olouioo_duration_hours]') || 3),selectionTiming(booking))).forEach(([name, value]) => data.set(`properties[${name}]`, value));
  }
  class EventCart extends HTMLElement {
    connectedCallback() {
      if (this._connected) return;
      this._connected = true;
      const details = this.querySelector('.olouioo-event-details');
      if (details) {
        details.open = eventExpanded;
        details.addEventListener('toggle', () => { eventExpanded = details.open; });
      }
      const date = this.querySelector('[data-shared-date]');
      const time = this.querySelector('[data-shared-time]');
      date.min = today();
      nextDay = this.dataset.nextDay || nextDay;
      const changed = () => {
        if (syncing || (date.value && !date.checkValidity()) || (time.value && !time.checkValidity())) return;
        setEvent({ date: date.value, time: time.value });
      };
      date.addEventListener('change', changed);
      time.addEventListener('change', changed);
      this.querySelector('[data-shared-save]').addEventListener('click', () => flush().catch(() => {}));
      ready.then(reflect);
    }
    async checkout() {
      if (this._checkingOut) return;
      const date = this.querySelector('[data-shared-date]');
      const time = this.querySelector('[data-shared-time]');
      if (!date.checkValidity() || !time.checkValidity()) {
        const details = this.querySelector('.olouioo-event-details');
        if (details) { details.open = true; eventExpanded = true; }
        else {
          const panel = document.getElementById('cart-drawer-event');
          if (panel?.openDialog) await panel.openDialog();
        }
        if (!date.reportValidity()) return;
        time.reportValidity();
        return;
      }
      setEvent({ date: date.value, time: time.value });
      this._checkingOut = true;
      try {
        // Heading straight to checkout: confirm the event details without re-rendering the cart.
        await flush(true);
        await persist({...state}, true);
        window.location.assign(root() + 'checkout');
      }
      catch { this._checkingOut = false; showStatus('error'); }
    }
  }
  document.addEventListener('cart:update', event => {
    const source = event.detail?.data?.source;
    if (source !== 'product-form-component' && event.detail?.sourceId !== 'olouioo-event') { lastPersisted = null; cartRevision++; }
    if(source!=='olouioo-event' && event.detail?.sourceId!=='olouioo-event'){
      clearTimeout(timingTimer);timingTimer=setTimeout(()=>request('cart.js').then(()=>{reflect();notifyTiming();}).catch(()=>{}),150);
    }
  });
  let timingFrame=0,timingTimer;
  function notifyTiming(){if(timingFrame)return;timingFrame=requestAnimationFrame(()=>{timingFrame=0;document.querySelectorAll('event-booking-fields').forEach(booking=>booking.refreshTiming?.());});}
  document.addEventListener('input',event=>{if(event.target.matches?.('[name=quantity],[data-omf-count],[data-hire-duration]'))notifyTiming();});
  ['change','quantity-selector:update','olouioo:service-state','olouioo:duration-change','olouioo:refreshment:draft'].forEach(name=>document.addEventListener(name,notifyTiming));
  ready.then(()=>{document.querySelectorAll('event-booking-fields').forEach(booking=>{if(!hydrated.has(booking))hydrate(booking);});notifyTiming();});
  window.OlouiooEvents = { hydrate, prepare, schedule, sync:async({quiet=false}={})=>{lastPersisted=null;await ready;if(valid(state)){try{return await persist({...state},quiet);}catch(error){showStatus('error');throw error;}}} };
  if (!customElements.get('olouioo-event-cart')) customElements.define('olouioo-event-cart', EventCart);
  document.addEventListener('submit', event => {
    if (event.submitter?.name !== 'checkout') return;
    const cards = [...document.querySelectorAll('olouioo-event-cart')];
    const card = event.submitter.closest('.cart-order-summary')?.querySelector('olouioo-event-cart') || cards.find(node => node.getClientRects().length) || cards[0];
    if (!card) return;
    event.preventDefault(); event.stopImmediatePropagation();
    card.checkout();
  }, true);
})();
